<img class="toast-icon" src="assets/images/boundary-violation.svg" alt="" width="24" height="24" />
<section class="text-container">
    <div *ngIf="title" [class]="options.titleClass">{{ title }}</div>
    <div *ngIf="message" [class]="options.messageClass" role="alert">{{ message }}</div>
</section>
